export default import.meta.ROLLDOWN_FILE_URL_Fg_8RJSAjCCbRcVpcV7dIQ